import { SimpleChanges } from '@angular/core';

export function propertyHasBeenEmptied(
  changes: SimpleChanges,
  property: string
): boolean {
  return (
    changes[property] &&
    !changes[property].currentValue &&
    !changes[property].firstChange
  );
}
